export const JOBAPPLICATION_COMPONENT_IDENT = {
    form: 'form',
    overview: 'overview',
    success: 'success'
};
